// Consultants & clinicians.
// SAMPLE DATA — names and profiles are placeholders until the client supplies the real team.
// `bmdcNo` is intentionally empty: never publish a registration number that is not real.
// `shortName` is used in the timetable grid. `social` links: empty = "#" placeholder.
// Chamber schedule lives in data/timetable.js (linked by doctorId).

export const departments = [
  { id: "psychiatry", name: "Psychiatry" },
  { id: "psychology", name: "Clinical Psychology" },
  { id: "counseling", name: "Addiction Counseling" },
];

const doctors = [
  {
    id: 1,
    slug: "prof-dr-md-rafiqul-islam",
    name: "Prof. Dr. Md. Rafiqul Islam",
    shortName: "Dr. Rafiqul. I",
    designation: "Senior Consultant Psychiatrist",
    department: "psychiatry",
    img: "/assets/images/team/1.jpg",
    degrees: "MBBS, FCPS (Psychiatry)",
    speciality: "Psychiatry",
    office: "Unity Health Centre, Near Circuit House, Gaital, Kishoreganj",
    university: "Bangabandhu Sheikh Mujib Medical University (BSMMU)",
    bmdcNo: "",
    experience: "20+ years",
    languages: ["Bangla", "English"],
    consultationFee: 1500,
    shortBio: "Senior psychiatrist with two decades of experience in mood disorders, psychosis and complex psychiatric conditions.",
    bio: "Prof. Dr. Md. Rafiqul Islam leads the psychiatry team at Unity Health Centre. He has extensive experience treating depression, bipolar disorder, schizophrenia and other complex psychiatric conditions, and supervises the inpatient treatment programme.",
    expertise: [
      "Major Depressive Disorder",
      "Bipolar Disorder",
      "Schizophrenia & Psychotic Disorders",
      "Treatment-resistant Depression",
    ],
    education: [
      {
        year: "2008",
        title: "FCPS (Psychiatry)",
        desc: "Bangladesh College of Physicians and Surgeons (BCPS).",
      },
      {
        year: "2002",
        title: "Post-graduate Psychiatry Training",
        desc: "Clinical training in adult psychiatry and psychopharmacology.",
      },
      { year: "1999", title: "MBBS", desc: "Government medical college, Bangladesh." },
    ],
    memberships: [
      { title: "Bangladesh Association of Psychiatrists", desc: "Life Member" },
      { title: "Medical Teaching", desc: "Teaches psychiatry to post-graduate trainees" },
      { title: "Clinical Supervisor", desc: "Supervises the inpatient treatment programme" },
      { title: "Academic Lectures", desc: "Mental health awareness & training programmes" },
    ],
    skills: [
      { name: "Psychopharmacology", value: 95 },
      { name: "Mood & Psychotic Disorders", value: 92 },
      { name: "Crisis Management", value: 88 },
    ],
    social: { facebook: "", twitter: "" },
    featured: true,
    order: 1,
  },
  {
    id: 2,
    slug: "dr-mahmudul-hasan",
    name: "Dr. Mahmudul Hasan",
    shortName: "Dr. Mahmud. H",
    designation: "Consultant Psychiatrist & Addiction Specialist",
    department: "psychiatry",
    img: "/assets/images/team/2.jpg",
    degrees: "MBBS, MD (Psychiatry)",
    speciality: "Addiction Psychiatry",
    office: "Unity Health Centre, Near Circuit House, Gaital, Kishoreganj",
    university: "Bangabandhu Sheikh Mujib Medical University (BSMMU)",
    bmdcNo: "",
    experience: "12+ years",
    languages: ["Bangla", "English"],
    consultationFee: 1200,
    shortBio: "Specialist in substance use disorders, detox management and dual diagnosis (addiction with mental illness).",
    bio: "Dr. Mahmudul Hasan specializes in addiction psychiatry. He manages medically supervised detoxification, withdrawal complications and dual-diagnosis cases, and designs relapse-prevention plans together with patients and families.",
    expertise: [
      "Drug & Alcohol Dependence",
      "Detox & Withdrawal Management",
      "Dual Diagnosis",
      "Relapse Prevention",
    ],
    education: [
      {
        year: "2014",
        title: "MD (Psychiatry)",
        desc: "Post-graduate degree in psychiatry, Bangladesh.",
      },
      {
        year: "2011",
        title: "Addiction Medicine Training",
        desc: "Clinical training in substance use disorders.",
      },
      { year: "2007", title: "MBBS", desc: "Government medical college, Bangladesh." },
    ],
    memberships: [
      { title: "Bangladesh Association of Psychiatrists", desc: "Member" },
      { title: "Community Awareness", desc: "Regular speaker on drug-abuse prevention" },
      { title: "Detox Unit Lead", desc: "Leads medically supervised detox" },
      { title: "Family Sessions", desc: "Guides families through recovery" },
    ],
    skills: [
      { name: "Detox & Withdrawal Management", value: 95 },
      { name: "Dual Diagnosis", value: 90 },
      { name: "Relapse Prevention", value: 88 },
    ],
    social: { facebook: "", twitter: "" },
    featured: true,
    order: 2,
  },
  {
    id: 3,
    slug: "dr-nasrin-sultana",
    name: "Dr. Nasrin Sultana",
    shortName: "Dr. Nasrin. S",
    designation: "Consultant Psychiatrist (Women & Adolescents)",
    department: "psychiatry",
    img: "/assets/images/team/3.jpg",
    degrees: "MBBS, MD (Psychiatry)",
    speciality: "Psychiatry (Women & Adolescents)",
    office: "Unity Health Centre, Near Circuit House, Gaital, Kishoreganj",
    university: "Dhaka Medical College",
    bmdcNo: "",
    experience: "10+ years",
    languages: ["Bangla", "English"],
    consultationFee: 1200,
    shortBio: "Focused on anxiety, depression, OCD and women's and adolescent mental health in a safe, private setting.",
    bio: "Dr. Nasrin Sultana provides psychiatric care for women and adolescents, including anxiety disorders, depression, OCD, postpartum mental health and exam or family stress. She also oversees the female ward.",
    expertise: [
      "Anxiety & Panic Disorders",
      "Obsessive-Compulsive Disorder (OCD)",
      "Postpartum Depression",
      "Child & Adolescent Mental Health",
    ],
    education: [
      {
        year: "2016",
        title: "MD (Psychiatry)",
        desc: "Post-graduate degree in psychiatry, Bangladesh.",
      },
      {
        year: "2013",
        title: "Child & Adolescent Psychiatry Training",
        desc: "Clinical attachment in child and adolescent mental health.",
      },
      { year: "2009", title: "MBBS", desc: "Government medical college, Bangladesh." },
    ],
    memberships: [
      { title: "Bangladesh Association of Psychiatrists", desc: "Member" },
      { title: "Female Ward", desc: "Clinical lead for women's inpatient care" },
      { title: "Adolescent Clinic", desc: "Weekly clinic for young people" },
      { title: "Awareness Talks", desc: "School and college mental health talks" },
    ],
    skills: [
      { name: "Anxiety & OCD", value: 94 },
      { name: "Adolescent Mental Health", value: 90 },
      { name: "Perinatal Psychiatry", value: 86 },
    ],
    social: { facebook: "", twitter: "" },
    featured: true,
    order: 3,
  },
  {
    id: 4,
    slug: "dr-tanvir-ahmed",
    name: "Dr. Tanvir Ahmed",
    shortName: "Dr. Tanvir. A",
    designation: "Resident Psychiatrist (Inpatient Unit)",
    department: "psychiatry",
    img: "/assets/images/team/4.jpg",
    degrees: "MBBS, DPM",
    speciality: "General Psychiatry",
    office: "Unity Health Centre, Near Circuit House, Gaital, Kishoreganj",
    university: "Mymensingh Medical College",
    bmdcNo: "",
    experience: "6+ years",
    languages: ["Bangla", "English"],
    consultationFee: 800,
    shortBio: "Looks after admitted patients day to day, emergency assessments and medication monitoring.",
    bio: "Dr. Tanvir Ahmed is the resident psychiatrist for the inpatient unit. He handles admissions, daily ward rounds, emergency assessments and close monitoring of medication and physical health.",
    expertise: [
      "Inpatient Care & Monitoring",
      "Psychiatric Emergencies",
      "Medication Review",
      "Physical Health Screening",
    ],
    education: [
      {
        year: "2020",
        title: "Diploma in Psychological Medicine (DPM)",
        desc: "Post-graduate diploma in psychiatry.",
      },
      { year: "2015", title: "MBBS", desc: "Medical college, Bangladesh." },
    ],
    memberships: [
      { title: "Inpatient Unit", desc: "Resident doctor, day shift" },
      { title: "Emergency Response", desc: "First responder for ward emergencies" },
      { title: "Patient Safety", desc: "Daily safety and medication checks" },
      { title: "Ward Rounds", desc: "Daily rounds with the nursing team" },
    ],
    skills: [
      { name: "Inpatient Care", value: 93 },
      { name: "Psychiatric Emergencies", value: 89 },
      { name: "Physical Health Monitoring", value: 85 },
    ],
    social: { facebook: "", twitter: "" },
    featured: false,
    order: 4,
  },
  {
    id: 5,
    slug: "md-arif-hossain",
    name: "Md. Arif Hossain",
    shortName: "Arif. H",
    designation: "Clinical Psychologist",
    department: "psychology",
    img: "/assets/images/team/6.jpg",
    degrees: "MS, MPhil (Clinical Psychology)",
    speciality: "Clinical Psychology",
    office: "Unity Health Centre, Near Circuit House, Gaital, Kishoreganj",
    university: "University of Dhaka",
    bmdcNo: "",
    experience: "8+ years",
    languages: ["Bangla", "English"],
    consultationFee: 1500,
    shortBio: "Provides CBT and other evidence-based therapy, psychological assessment and family sessions.",
    bio: "Md. Arif Hossain is a clinical psychologist offering cognitive behavioural therapy (CBT), motivational interviewing, psychological testing and family therapy for both outpatients and admitted patients.",
    expertise: [
      "Cognitive Behavioural Therapy (CBT)",
      "Psychological Assessment",
      "Stress, Grief & Trauma",
      "Family & Couples Therapy",
    ],
    education: [
      {
        year: "2017",
        title: "MPhil (Clinical Psychology)",
        desc: "Department of Clinical Psychology, Bangladesh.",
      },
      { year: "2014", title: "MS (Psychology)", desc: "Public university, Bangladesh." },
    ],
    memberships: [
      { title: "Clinical Psychology Society", desc: "Member" },
      { title: "Psychometric Testing", desc: "Standardised psychological assessments" },
      { title: "Group Therapy", desc: "Runs weekly therapy groups" },
      { title: "Trauma Support", desc: "Grief and trauma-focused sessions" },
    ],
    skills: [
      { name: "Cognitive Behavioural Therapy", value: 95 },
      { name: "Psychological Assessment", value: 91 },
      { name: "Family Therapy", value: 87 },
    ],
    social: { facebook: "", twitter: "" },
    featured: true,
    order: 5,
  },
  {
    id: 6,
    slug: "shahidul-alam",
    name: "Shahidul Alam",
    shortName: "Shahidul. A",
    designation: "Senior Addiction Counselor",
    department: "counseling",
    img: "/assets/images/team/5.jpg",
    degrees: "MSS (Counseling Psychology), Certified Addiction Counselor",
    speciality: "Addiction Counseling",
    office: "Unity Health Centre, Near Circuit House, Gaital, Kishoreganj",
    university: "University of Dhaka",
    bmdcNo: "",
    experience: "9+ years",
    languages: ["Bangla"],
    consultationFee: 1000,
    shortBio: "Runs individual and group counseling, the 12-step programme and family education sessions.",
    bio: "Shahidul Alam leads the counseling team. He conducts individual and group counseling, the 12-step recovery programme, life-skills training and family education sessions for patients in rehabilitation.",
    expertise: [
      "Individual & Group Counseling",
      "12-Step Recovery Programme",
      "Life-skills Training",
      "Family Education",
    ],
    education: [
      {
        year: "2016",
        title: "Addiction Counselor Certification",
        desc: "Professional training in addiction counseling.",
      },
      {
        year: "2013",
        title: "MSS (Counseling Psychology)",
        desc: "Public university, Bangladesh.",
      },
    ],
    memberships: [
      { title: "Rehabilitation Programme", desc: "Lead counselor" },
      { title: "Recovery Mentor", desc: "Mentors patients after discharge" },
      { title: "Family Education", desc: "Weekly family education sessions" },
      { title: "NA Meetings", desc: "Facilitates weekly NA meetings" },
    ],
    skills: [
      { name: "Group Counseling", value: 95 },
      { name: "12-Step Facilitation", value: 92 },
      { name: "Life-skills Training", value: 88 },
    ],
    social: { facebook: "", twitter: "" },
    featured: true,
    order: 6,
  },
];

export default doctors;
